import React from 'react';
import HBTableRow from './HBTableRow';
import { HBTableBodyProps } from './HBTable.types';
import { Table } from './HBTable.styles';
import HBTableHorizontalShadowSyncScrollContainer from './HBTableHorizontalShadowSyncScrollContainer';
import { useFocusGroup } from '../../hooks/useFocusGroup';

function HBTableBody<T>({ table, setTableBodyEl }: HBTableBodyProps<T>) {
    useFocusGroup(`${Table} ${HBTableRow.TR}`, { ltr: false });

    if (table.options.meta.isInitialLoading) {
        return null;
    }

    const rows = table.getRowModel().rows;
    const { emptyState } = table.options.meta;

    if (rows.length === 0 && emptyState) {
        return <>{emptyState}</>;
    }

    return (
        <HBTableHorizontalShadowSyncScrollContainer table={table}>
            <Table ref={setTableBodyEl}>
                <tbody>
                    {rows.map(row => (
                        <HBTableRow
                            key={row.id}
                            row={row}
                            table={table}
                            isLoading={table.options.meta.isLoading}
                        />
                    ))}
                </tbody>
            </Table>
        </HBTableHorizontalShadowSyncScrollContainer>
    );
}

export default HBTableBody;
